import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '90vh',
  },
  body: {
    paddingBottom: theme.spacing(6),
  },
}))

export default useStyles
